// src/pages/RagJobsPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ragKbOverview } from "../api/client";
import "../styles/rag.css";
import "../styles/base.css";

export default function RagJobsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await ragKbOverview();
        setRows(data);
      } catch (err) {
        console.error("Failed to load KB overview", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <div className="rag-page">Loading KB overview...</div>;
  }

  return (
    <div className="rag-page">
      <div className="rag-header">
        <h1>RAG Knowledge Bases – Overview</h1>
        <p className="rag-subtitle">
          Existing KBs with number of files and RAG endpoint URL. Click on the KB
          name to manage uploads & index jobs.
        </p>
      </div>

      <div className="table-container">
        <table className="rag-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>KB Name</th>
              <th>Project</th>
              <th>Slug</th>
              <th># Files</th>
              <th>LLM / Embed</th>
              <th>RAG URL</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const llmModel = row.indexing_options?.llm_model || "llama3.1:8b";
              const ragUrl = `/api/search/collections/${row.id}/ask`;

              return (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>
                    <Link to={`/rag/kb/${row.id}`}>{row.name}</Link>
                  </td>
                  <td>{row.project_id ?? "-"}</td>
                  <td>{row.slug}</td>
                  <td>{row.doc_count}</td>
                  <td>
                    <code style={{ fontSize: 11.5 }}>{llmModel}</code>
                    <br />
                    <small>embed: {row.embedding_model}</small>
                  </td>
                  <td>
                    <code style={{ fontSize: 11.5 }}>{ragUrl}</code>
                  </td>
                </tr>
              );
            })}
            {rows.length === 0 && (
              <tr>
                <td colSpan={7}>No Knowledge Bases found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
